import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

const Map = ({ onLoad, ...props }) => {
  useEffect(() => {
    if (onLoad) onLoad();
  }, [onLoad]);

  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 1920 1066"
    >
      <polygon
        data-floor="0"
        points="404 842 466 906 486 902 572 980 918 866 932 872 1184 789 1203 793 1449 708 1451 655 1443 656 1442 677 1241 739 1222 734 1080 776 1047 764 954 793 954 807 745 870 715 851 568 894 548 878 487 894 422 836 404 839.58 404 842"
      />
      <polygon
        data-floor="1"
        points="320 758 404 839.58 422 836 487 894 548 878 568 894 715 851 745 870 954 807 954 793 1047 764 1080 776 1222 734 1241 739 1442 677 1443 656 1451 655 1455 604 1443 607 1443 610 1243 663 1224 657 1081 694 1047 682 951 704 951 720 741 774 709 757 560 791 542 781 480 795 417 744 397.29 749 352 710 313 717 320 758"
      />
      <polygon
        data-floor="2"
        points="313 678.45 352 710 397.29 749 417 744 480 795 542 781 560 791 709 757 741 774 951 720 951 704 1047 682 1081 694 1224 657 1243 663 1443 610 1443 607 1455 604 1460 535 1448 537 1448 540 1247 584 1228 579 1083 611 1048 602 953 623 953 631 738 675 707 662 555 689 536 681 471 693 409 650 388.22 655 352 629 352 632 308 640 313 678.45"
      />
      <polygon
        data-floor="3"
        points="306 598 352 629 388.22 655 409 650 471 693 536 681 555 689 707 662 738 675 953 631 953 623 1048 602 1083 611 1228 579 1247 584 1448 540 1448 537 1460 535 1464 470 1253 504 1229 501 1084 523 1050 517 953 531 953 540 735 574 704 565 539 586 529 579 465 587 402 556 383 558 344 540 345 552 301 557 306 598"
      />
      <polygon
        data-floor="4"
        points="298 515 344 540 383 558 402 556 465 587 529 579 539 586 704 565 735 574 953 540 953 531 1050 517 1084 523 1229 501 1253 504 1464 470 1469 399 1254 422 1233 420 1085 436 1050 431 952 440 952 447 729.06 470 700 463 544 475 523 473 456 479 394 457 373 459 336 446 336.12 470 293 473 298 515"
      />
      <polygon
        data-floor="5"
        points="291 428 336 446 373 459 394 457 456 479 523 473 544 475 700 463 729.06 470 952 447 952 440 1050 431 1085 436 1233 420 1254 422 1469 399 1474 327 1262 339 1233 338 1087 345 1051 343 952 345 952 351 728 363 695 359 533 366 516 364 450 367 385 356 367 356 329 351 329 386 286 388 291 428"
      />
      <polygon
        data-floor="6"
        points="282 341 329 351 367 356 385 356 450 367 516 364 533 366 695 359 728 363 952 351 952 345 1051 343 1087 345 1233 338 1262 339 1474 327 1479 254 1262 253 1216.57 253 1090.95 253 1052.03 253 951.47 253 728 252 691.7 252 514 253 510.05 252 435.99 252 376.76 252 353.62 252 319.33 252 321 300 278 300 282 341"
      />
      <polygon
        data-floor="7"
        points="273.64 252 319.33 252 355.71 252 380.1 252 423.31 252 510.05 252 514 253 560.26 252.5 639.18 252.3 728 252 820.17 252 1004.37 253 1117.64 253 1262 253 1428.73 253.77 1479 254 1484 177 1276 165 1278 100 1186 90 1186 86 1187.74 86 1188 84 1176.07 84 1176 83 1160.01 83 1160 84 1152 84 1152 86 1136 86 1136 73 1018 60 1018 46 867 30 798 42 781 42 765 45 765 52 745 51 733 53 733 55 735 55 735 84 688 94 688 96 689 96 690 127 665 128 665 131 586 128 586 120 589 120 589 118 552 117 532 121 532 124 519 124 448 137 416 140 410 140 367 148 367 153 345 153 269 168 313 171 315 205 267 210 267 210.79 270 211 273.64 252"
      />
    </svg>
  );
};

Map.propTypes = {
  onLoad: PropTypes.func.isRequired,
};

export default Map;
